import _ from "lodash";

interface Dom{
    nodeType:number
    nodeName:string
}
const isDOM =
    typeof HTMLElement === 'object'
        ? function(dom:Dom|undefined) {
            return dom instanceof HTMLElement;
        }
        : function(dom:Dom | undefined) {
            return dom && typeof dom === 'object' && dom.nodeType === 1 && typeof 	dom.nodeName === 'string';
        };
export function isSimpleValue(v:any){
    switch (v){
        case undefined:
        case null:
        case _.isDate(v):
        case _.isBoolean(v):
        case _.isInteger(v):
        case _.isNaN(v):
        case _.isNull(v):
        case _.isNumber(v):
        case _.isSymbol(v):
        case _.isString(v):
            return true;
        default:
            return false;
    }
}

export function isConsulePrintable(v:Dom){
    const isSimple = isSimpleValue(v);
    if(isSimple)return true;
    if(isDOM(v))return true;
    return false;
}
